import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-top" }
const _hoisted_4 = { class: "title-box" }
const _hoisted_5 = { class: "top-icon" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "name-text" }
const _hoisted_9 = { class: "card-top card-center" }
const _hoisted_10 = { class: "title-box" }
const _hoisted_11 = { class: "title-count" }
const _hoisted_12 = { class: "card-bottom" }
const _hoisted_13 = { class: "desc" }
const _hoisted_14 = { class: "drawer-contain" }
const _hoisted_15 = { class: "drawer-header" }
const _hoisted_16 = { class: "drawer-header-rt" }
const _hoisted_17 = { class: "drawer-rt-btns" }
const _hoisted_18 = { class: "table" }
const _hoisted_19 = { class: "drawer-contain" }
const _hoisted_20 = { class: "drawer-header" }
const _hoisted_21 = { class: "drawer-header-rt" }
const _hoisted_22 = { class: "drawer-rt-btns" }
const _hoisted_23 = { class: "drawer-content" }
const _hoisted_24 = {
  key: 0,
  class: "img-box"
}
const _hoisted_25 = ["src"]
const _hoisted_26 = {
  key: 1,
  class: "img-box"
}
const _hoisted_27 = { class: "terms-section" }
const _hoisted_28 = { class: "desc-box" }
const _hoisted_29 = { class: "drawer-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_More = _resolveComponent("More")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_Back = _resolveComponent("Back")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_Download = _resolveComponent("Download")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planList, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "list",
          key: index + item.id
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  class: "top-icon-img",
                  src: item.fileUrl,
                  alt: ""
                }, null, 8, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("text", null, _toDisplayString(item.name), 1),
                  _cache[5] || (_cache[5] = _createTextVNode()),
                  _createElementVNode("text", {
                    class: _normalizeClass(['name-status',item.enable == 1 ? 'name-status1' : 'name-status0'])
                  }, _toDisplayString(item.enable == 1 ? '启用' : '禁用'), 3)
                ])
              ])
            ]),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: ($event: any) => (_ctx.toDetail(item))
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("查看保司资料")
              ])),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[7] || (_cache[7] = _createTextVNode(" 当前在保 ")),
              _createElementVNode("text", _hoisted_11, _toDisplayString(item.count) + "人", 1)
            ]),
            _createVNode(_component_el_button, {
              onClick: ($event: any) => (_ctx.onLinkWorkers(item))
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("人员详情")
              ])),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[9] || (_cache[9] = _createElementVNode("div", null, "资料补充", -1)),
            _createElementVNode("div", _hoisted_13, _toDisplayString(item.specialRemark ? item.specialRemark :'暂无资料补充'), 1)
          ])
        ]))
      }), 128)),
      (!_ctx.planList.length)
        ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 0,
            description: "暂无方案"
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.showPeopleInsure,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showPeopleInsure) = $event)),
      size: "70%",
      "with-header": false,
      "show-close": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "drawer-header-lt" }, [
              _createElementVNode("div", { class: "drawer-lt-title" }, " 在保人数 ")
            ], -1)),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_el_dropdown, { trigger: "click" }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_dropdown_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: "text",
                              onClick: _ctx.onDetailExport
                            }, {
                              default: _withCtx(() => _cache[10] || (_cache[10] = [
                                _createTextVNode("导出")
                              ])),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, { size: "small" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_More)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: _ctx.goBack
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Back)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              inline: true,
              model: _ctx.peopleFormSearch,
              class: "demo-form-inline"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.peopleFormSearch.searchUserInfo,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.peopleFormSearch.searchUserInfo) = $event)),
                      placeholder: "请输入出险姓名或身份证",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _ctx.onPeopleInsureSearch
                    }, {
                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createTextVNode("搜索")
                      ])),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_button, { onClick: _ctx.onPeopleInsureReset }, {
                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                        _createTextVNode("重置")
                      ])),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_el_table, {
              data: _ctx.peopleInsureList,
              style: {"width":"100%","min-height":"750px"},
              border: "",
              "header-cell-style": { background: '#FBFBFD' },
              "header-row-style": { color: '#202536' },
              "row-style": { color: '#5E617D' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "userName",
                  label: "员工姓名"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "idCardNo",
                  label: "身份证号"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "",
                  label: "在保时间"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("span", null, _toDisplayString(scope.row.insureStartTime) + "-" + _toDisplayString(_ctx.checkInsureEndTime(scope.row.insureEndTime)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "serveCompanyName",
                  label: "派遣单位"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "occupationName",
                  label: "工种"
                })
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_el_pagination, {
              class: "pagination",
              currentPage: _ctx.staffRecordPage,
              "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.staffRecordPage) = $event)),
              "page-size": _ctx.staffRecordSize,
              "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.staffRecordSize) = $event)),
              "page-sizes": [10, 30, 50, 100],
              layout: "total, sizes, prev, pager, next, jumper",
              total: _ctx.staffRecordTotal,
              onSizeChange: _ctx.peopleInsureSizeChange,
              onCurrentChange: _ctx.initPeopleInsureList
            }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.showPlanInfo,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showPlanInfo) = $event)),
      size: "900px",
      "with-header": false,
      "show-close": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "drawer-header-lt" }, [
              _createElementVNode("div", { class: "drawer-lt-title" }, " 保司资料 ")
            ], -1)),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: _ctx.goBack
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Back)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            (_ctx.infoUrl)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("img", {
                    src: _ctx.infoUrl,
                    class: "icon-img",
                    alt: ""
                  }, null, 8, _hoisted_25)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createVNode(_component_el_empty, { description: "暂无方案图片详情" })
                ])),
            _createElementVNode("div", _hoisted_27, [
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "desc-header" }, "方案条款说明：", -1)),
              _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.planTermsData.dictValue), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            (_ctx.commitmentUrl.length>0)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  onClick: _ctx.onDownLoadCommitment
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Download)
                      ]),
                      _: 1
                    }),
                    _cache[16] || (_cache[16] = _createTextVNode("承诺函"))
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.reportCaseFileUrl)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  type: "primary",
                  onClick: _ctx.onDownLoadReportCase
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Download)
                      ]),
                      _: 1
                    }),
                    _cache[17] || (_cache[17] = _createTextVNode("理赔材料"))
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}